export const isUrgentOptions = [
  {
    id: 'Yes',
    title: 'Yes',
    description: 'I have an urgent issue',
  },
  {
    id: 'No',
    title: 'No',
    description: 'I just need a new dentist',
  },
];

export const specialistTriagingOptions = [
  {
    id: 'new-dentist',
    title: 'A New Dentist',
    description: 'For routine checkups, cleanings, or general dental care.',
  },
  {
    id: 'specialist',
    title: 'A Specialist',
    description:
      'For specific needs like braces, wisdom teeth removal, or gum treatment.',
  },
  {
    id: 'urgent',
    title: 'Urgent Care',
    description: 'For pain, broken teeth, or other immediate dental issues.',
  },
];
